import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const NodeJSIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width={50}
    height={50}
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="m22.79,1.2c1.33,-0.69 3.06,-0.69 4.39,0c6.69,3.43 13.37,6.85 20.06,10.27c1.26,0.64 2.1,1.91 2.09,3.23l0,20.61c0.01,1.37 -0.91,2.67 -2.24,3.29c-6.66,3.41 -13.32,6.82 -19.99,10.23c-1.36,0.71 -3.13,0.65 -4.44,-0.11c-2,-1.05 -4,-2.1 -6,-3.14c-0.41,-0.22 -0.87,-0.4 -1.16,-0.75c0.26,-0.31 0.71,-0.35 1.08,-0.49c0.83,-0.24 1.6,-0.63 2.37,-1c0.19,-0.12 0.43,-0.08 0.61,0.04c1.71,0.89 3.4,1.8 5.12,2.68c0.37,0.19 0.74,-0.06 1.05,-0.22c6.54,-3.35 13.09,-6.69 19.62,-10.04c0.24,-0.11 0.38,-0.34 0.36,-0.58c0,-6.8 0,-13.6 0,-20.4c0.03,-0.28 -0.14,-0.52 -0.42,-0.64c-6.64,-3.39 -13.28,-6.79 -19.91,-10.18a0.69,0.63 0 0 0 -0.78,0c-6.64,3.39 -13.27,6.8 -19.91,10.18c-0.27,0.11 -0.45,0.36 -0.42,0.63c0,6.8 0,13.6 0,20.4a0.64,0.58 0 0 0 0.36,0.57c1.77,0.91 3.54,1.81 5.32,2.72c1,0.49 2.22,0.78 3.32,0.4c0.97,-0.31 1.65,-1.22 1.63,-2.15c0.01,-6.76 0,-13.52 0.01,-20.28c-0.03,-0.3 0.29,-0.55 0.61,-0.52c0.85,-0.01 1.71,-0.01 2.55,0c0.36,-0.01 0.6,0.31 0.56,0.62c0,6.8 0.01,13.61 -0.01,20.41c0,1.81 -0.82,3.79 -2.67,4.67c-2.28,1.07 -5.09,0.84 -7.34,-0.18c-1.95,-0.88 -3.81,-1.92 -5.72,-2.87c-1.33,-0.62 -2.25,-1.93 -2.24,-3.3l0,-20.61c-0.02,-1.34 0.86,-2.64 2.16,-3.27c6.66,-3.41 13.32,-6.82 19.98,-10.24l0,0l0,0.01l0,0.01z"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="m29.66,16.16c2.69,-0.16 5.57,-0.1 8,1.13c1.88,0.94 2.91,2.91 2.95,4.84c-0.05,0.26 -0.35,0.4 -0.62,0.38c-0.78,0 -1.56,0.01 -2.34,-0.01c-0.33,0.01 -0.53,-0.27 -0.56,-0.54c-0.23,-0.92 -0.77,-1.83 -1.71,-2.28c-1.44,-0.67 -3.11,-0.63 -4.68,-0.62c-1.15,0.06 -2.38,0.15 -3.35,0.77c-0.75,0.47 -0.97,1.42 -0.71,2.19c0.25,0.55 0.94,0.73 1.5,0.89c3.25,0.79 6.68,0.71 9.86,1.74c1.32,0.42 2.61,1.24 3.06,2.51c0.59,1.71 0.33,3.75 -0.98,5.12c-1.07,1.13 -2.62,1.74 -4.17,2.07c-2.06,0.43 -4.2,0.44 -6.3,0.25c-1.97,-0.21 -4.02,-0.69 -5.54,-1.92c-1.3,-1.04 -1.93,-2.67 -1.87,-4.24c0.02,-0.27 0.3,-0.45 0.57,-0.43c0.78,-0.01 1.57,-0.01 2.36,0c0.32,-0.02 0.55,0.23 0.56,0.5c0.15,0.88 0.5,1.8 1.33,2.32c1.6,0.95 3.61,0.89 5.43,0.92c1.52,-0.06 3.22,-0.08 4.46,-1.01c0.65,-0.53 0.85,-1.41 0.67,-2.18c-0.19,-0.64 -0.92,-0.94 -1.54,-1.13c-3.2,-0.94 -6.68,-0.6 -9.85,-1.66c-1.29,-0.42 -2.53,-1.21 -3.03,-2.44c-0.69,-1.73 -0.37,-3.87 1.08,-5.2c1.42,-1.32 3.46,-1.82 5.41,-2.01l0,0l0.02,0.01l0,0.01z"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
)
const ForwardRef = forwardRef(NodeJSIcon)
export { ForwardRef as ReactComponent }
